import { ConnectButton } from '@rainbow-me/rainbowkit';
export default  function ConnectButtonComp(){
  return <ConnectButton />;
};